import {
  TRANSLATE_INTO_JAPANESE,
  TRANSLATE_INTO_ENGLISH,
  INCREASE_FONT_SIZE,
  DECREASE_FONT_SIZE,
  OPEN_DRAWER,
  CLOSE_DRAWER,
} from 'constants/actionTypes'

export const translateIntoJapanese = () => ({
  type: TRANSLATE_INTO_JAPANESE,
})

export const translateIntoEnglish = () => ({
  type: TRANSLATE_INTO_ENGLISH,
})

export const increaseFontSize = () => ({
  type: INCREASE_FONT_SIZE,
})

export const decreaseFontSize = () => ({
  type: DECREASE_FONT_SIZE,
})

export const openDrawer = () => ({
  type: OPEN_DRAWER,
})

export const closeDrawer = () => ({
  type: CLOSE_DRAWER,
})

export interface Action {
  type: string
}
